import { render } from "./MovieList.vue?vue&type=template&id=18c01b53"
import script from "./MovieList.vue?vue&type=script&lang=js"
export * from "./MovieList.vue?vue&type=script&lang=js"
script.render = render

export default script